import { render, staticRenderFns } from "./driverReview.vue?vue&type=template&id=bbe652e6&scoped=true"
import script from "./driverReview.vue?vue&type=script&lang=js"
export * from "./driverReview.vue?vue&type=script&lang=js"
import style0 from "./driverReview.vue?vue&type=style&index=0&id=bbe652e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe652e6",
  null
  
)

export default component.exports